export const VENUE_SERP = 'venueSerp';
export const SEARCH = 'search';
